import { BoxStyleProps } from "@twilio-paste/core/box";

// Rodapé do chat: empilha (previews de anexo em cima) + linha de input embaixo. Padding 12px.
export const formStyles: BoxStyleProps = {
    borderTopColor: "colorBorderWeaker",
    borderTopWidth: "borderWidth10",
    borderTopStyle: "solid",
    padding: "space40",
    display: "flex",
    flexDirection: "column"
};

// Linha do input: [clipe FORA da pílula] [pílula]
export const inputRowStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
};

// Clipe de anexo: fora da pílula, à esquerda, com 8px de gap
export const attachButtonContainerStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "center",
    marginRight: "space30"
};

// Wrapper que faz a pílula (InputBox) ocupar o resto da linha
export const inputBoxWrapperStyles: BoxStyleProps = {
    flex: 1
};

export const innerInputStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%"
};

export const textAreaContainerStyles: BoxStyleProps = {
    marginTop: "auto",
    marginBottom: "auto",
    flex: 1
};

// Botão de enviar (dentro da pílula, à direita)
export const messageOptionContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
};

// Previews de anexo, acima da linha de input
export const filePreviewContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    maxHeight: "300px",
    position: "relative",
    marginBottom: "space30",
    paddingLeft: "space30",
    paddingRight: "space30"
};
